<span [ngSwitch]="status.statusCode">
  <span class="badge-status grey" *ngSwitchCase="monitorTaskStatusEnum.New">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="monitorTaskStatusEnum.Active">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="monitorTaskStatusEnum.Waiting_First_Review">
    {{status.title}}
  </span>
  <span class="badge-status purple" *ngSwitchCase="monitorTaskStatusEnum.Modifications_Requested_From_First_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="monitorTaskStatusEnum.Waiting_Final_Review">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border"
    *ngSwitchCase="monitorTaskStatusEnum.Modifications_Requested_From_Final_Review">
    {{status.title}}
  </span>
  <span class="badge-status orange_ff" *ngSwitchCase="monitorTaskStatusEnum.Waiting_Final_Approval">
    {{status.title}}
  </span>
  <span class="badge-status success-with-border" *ngSwitchCase="monitorTaskStatusEnum.Final_Report_Approved">
    {{status.title}}
  </span>
  <span class="badge-status red_2" *ngSwitchCase="monitorTaskStatusEnum.Final_Report_Rejected">
    {{status.title}}
  </span>
  <span class="badge-status danger-with-border" *ngSwitchCase="monitorTaskStatusEnum.Overdue">
    {{status.title}}
  </span>
</span>